module.exports = __webpack_public_path__ + "media/images/lb/447-3020278e10ddc66f6243b655ed79f4ad.svg";